import React from 'react'
import {Card} from "reactstrap";
import PizzaCard from './PizzaCard'
import BarrasCard from './BarrasCard'
import LinhaCard from './LinhaCard'
import StackedBar from './StackedBar';
import Loading from '../../lib/loading'
import BarrasMes from './BarrasMes';
import BarrasHora from './BarrasHora';
import BarrasQtde from './BarrasQtde';
import PizzaQtde from './PizzaQtde';
import BarrasHorizontal from './BarrasHorizontal';
import VerticalBar from './VerticalBar';

const graficos = {
  PizzaCard,
  BarrasCard,
  LinhaCard,
  StackedBar,
  BarrasMes,
  BarrasHora,
  BarrasQtde,
  PizzaQtde,
  BarrasHorizontal,
  VerticalBar,
}

const Grafico = ({ loading, lista, title, color, component }) => {

  if (loading) {
    return (
      <div>
        <Card>
          <Loading
            tipo='componente'
          />
        </Card>
      </div>
    )
  }

  var Component = graficos[component]

  // grafico usando modulo strackerbar
  if (title == "Vendas Por Forma de Pagamento Por Lojas" || title == "Vendas Por CMV") {
    
    Component = graficos['StackedBar']
  }

  return (
    <Component
      color={color}
      title={title}
     // dados={fixo ? fixo : nulo}
      dados={lista}
    />
  )
}

export default Grafico
